<template>
	<span class="operate-group">
        <span class="icon-reduce" @click.stop.prevent="reduce"></span>
        <span class="text-counter">{{counts}}</span>
        <span class="icon-plus" @click.stop.prevent="plus"></span>
    </span>

</template>

<script>
	export default {
		props:['count','item','index','saleStatus'],
		data(){
			return {
				counts: 0

			}
		},
		watch:{
			count(val,oldVal){
				this.counts =  val;
			}
		},
		mounted(){
			this.counts =  this.count;
		},
		methods: {
			reduce(){
				if(this.saleStatus == 1) return false;
				if(this.counts >1 ){
					-- this.counts;
					this.$emit('reduce',this.counts,this.item,this.index);
				}
			},
			plus(){
				if(this.saleStatus == 1) return false;
				++ this.counts;
				this.$emit('plus',this.counts,this.item,this.index);
			}
		}

	}
</script>


// WEBPACK FOOTER //
// counter.vue?294f65ae